export const PARTNER_URLS = {
  DISABILITY: (params: Object) => {
    const { user_id } = params;

    return `https://www.meetbreeze.com/offer/1006?pvar1=${user_id}&utm=stride`;
  },
};
